<script>
	const Vue = require('vue');
	const TTSPlayerSimple = require('components/text-to-speech-player-simple.vue').default;
	const _ = require('underscore');

	module.exports = {
		props: {
			content: {
				default: '',
				type: String
			},
			showTts: {
				default: false,
				type: Boolean
			},
			eventData: {
				default: {},
				type: Object
			}
		},
		data() {
			return {
				subComponent: null,
				updateSubComponent: () => {}
			};
		},
		methods: {
			async generateSubComponent() {
				if (!this.showTts || !this.content.trim()) {
					return;
				}

				await Vue.nextTick();

				if (!this.$refs.content) return;

				// Inject TTS player into last element containing text to force it inline with text
				// Many questions contain block elements in their HTML
				// CSS only fix not possible — making the last element inline would counter the intended UI
				const el = document.createElement('span');
				const eventData = this.eventData;

				const contentEl = this.$refs.content;

				let lastChildWithText = this.$el;
				for (let i = contentEl.children.length - 1; i >= 0; i--) {
					const child = contentEl.children[i];
					if (child.textContent.trim()) {
						lastChildWithText = child;
						break;
					}
				}

				lastChildWithText.append(' ');
				lastChildWithText.appendChild(el);

				// Store reference to enable teardown on update and destroy
				this.subComponent = new (Vue.extend(TTSPlayerSimple))({
					el,
					propsData: {
						eventData,
						text: contentEl.textContent.trim()
					}
				});
			},

			destroySubComponent() {
				const subComponent = this.subComponent;

				if (subComponent) {
					subComponent.$el.remove();
					subComponent.$destroy();
					this.subComponent = null;
				}
			},
			_updateSubComponent() {
				this.destroySubComponent();
				this.generateSubComponent();
			}
		},
		watch: {
			showTts() {
				this.updateSubComponent();
			},
			eventData() {
				this.updateSubComponent();
			}
		},
		created() {
			// assign debounce here instead of in methods to prevent unintentional leakage when several instances present
			this.updateSubComponent = _.debounce(this._updateSubComponent, 10);
		},
		mounted() {
			this.generateSubComponent();
		},
		updated() {
			this.updateSubComponent();
		},
		beforeDestroy() {
			this.destroySubComponent();
		}
	};
</script>
<template>
	<span class="question-text">
		<span
			ref="content"
			v-html="content"></span>
	</span>
</template>
